import { Button, Modal, Stack, Textarea } from '@mantine/core'
import { useState } from 'react'
import { DeviceAdvertisementsForHost } from '../models/DeviceAdvertisementsForHost'

interface DenyAdModalProps {
  adToDeny: DeviceAdvertisementsForHost | null
  isOpen: boolean
  onClose: () => void
  onConfirm: (adId: number, denialReason: string) => Promise<void>
  isDenying: boolean
}

export function DenyAdModal({
  adToDeny: ad,
  isOpen,
  onClose,
  onConfirm,
  isDenying,
}: DenyAdModalProps) {
  const [denialReason, setDenialReason] = useState('')

  const handleConfirm = async () => {
    if (!ad) return
    await onConfirm(ad.id, denialReason)
    setDenialReason('')
  }

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title='Deny Advertisement'
      centered
      size='md'
    >
      <Stack>
        <Textarea
          label='Denial Reason'
          placeholder='Enter the reason for denying this advertisement...'
          value={denialReason}
          onChange={(e) => setDenialReason(e.target.value)}
          rows={4}
          required
        />
        <div
          style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}
        >
          <Button variant='default' onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            loading={isDenying}
            disabled={!denialReason.trim()}
            loaderProps={{
              type: 'dots',
            }}
          >
            Confirm Denial
          </Button>
        </div>
      </Stack>
    </Modal>
  )
}
